import { render, staticRenderFns } from "./CatalogueProducts.vue?vue&type=template&id=d2da0ce6"
import script from "./CatalogueProducts.vue?vue&type=script&lang=js"
export * from "./CatalogueProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports